import React from "react";
import PanelHead from "../../UI/Panel/PanelHead";
import PanelBody from "../../UI/Panel/PanelBody";
import { OrdersTable } from "../../UI/Orders/OrdersTable";

const OrdersPanel = () => {
  return (
    <div>
      <PanelHead title="Orders" />
      <PanelBody content={<OrdersTable />} />
    </div>
  );
};

export default React.memo(OrdersPanel);
